import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-paciente-layout',
    templateUrl: './paciente-layout.component.html',
    styleUrls: ['./paciente-layout.component.scss'],
    standalone: false
})
export class PacienteLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
